import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import MoveableImage from "../components/MoveableImage/MoveableImage"; // Import the new component
import colors from "../styles/colors";
import { contentBoxStyle, imageContainerStyle } from "../styles/commonStyles";

const Design: React.FC = () => {
  // Define image paths using PUBLIC_URL
  const machinedrum = `${process.env.PUBLIC_URL}/design/Machinedrum.png`;
  const Q = `${process.env.PUBLIC_URL}/design/Q.png`;
  const Glitch1 = `${process.env.PUBLIC_URL}/design/Glitch1.jpg`;
  const Glitch2 = `${process.env.PUBLIC_URL}/design/Glitch2.jpg`;
  const Flower1 = `${process.env.PUBLIC_URL}/design/Flower1.jpg`;
  const Flower2 = `${process.env.PUBLIC_URL}/design/Flower2.jpg`;
  const Project1 = `${process.env.PUBLIC_URL}/design/project.jpg`;
  const Rotation = `${process.env.PUBLIC_URL}/design/Rotation.gif`;
  const Bremsschuhe = `${process.env.PUBLIC_URL}/design/Bremsschuhe.jpg`;
  const Hoods = `${process.env.PUBLIC_URL}/design/Hoods.jpg`;

  return (
    <Box
      id="content"
      sx={{
        ...contentBoxStyle,
      }}
    >
      <Box
        id="text-container"
        sx={{
          maxWidth: "1564px",
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr", // 1 column on extra small screens
            sm: "1fr 1fr", // 2 columns on small screens (1:1 ratio)
            md: "2fr 2fr", // 3 columns on medium screens (1:2 ratio)
          },
          gap: "2rem",
          paddingTop: "10rem",
          paddingBottom: "5rem",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            backgroundColor: "white",
            wordBreak: "break-word",
            borderRadius: "0px 0px 0px 0px",
            boxShadow: "2px 2px 4px rgba(174, 130, 200, 0.5)",
          }}
        >
          <Typography
            variant="h1"
            sx={{
              color: colors.filterColors[2],
              margin: "1rem",
            }}
          >
            Design
          </Typography>
        </Box>
        <Box
          sx={{
            color: "white",
            borderRadius: "50px 0px 50px 0px",
            backgroundColor: colors.filterColors[2],
          }}
        >
          <Typography variant="body1" margin="1.5rem 1.8rem">
            <p>
              Design became a big part of my life early on because I was always
              a bit of a perfectionist.
            </p>
            <p>
              I found myself questioning the surface of things, constantly
              curious about why things were the way they were, how they could be
              improved, and why certain aspects didn't need improvement at all.
              This natural inclination to dig deeper and seek better solutions
              shaped my passion for design and the way I approach everything I
              create.
            </p>
          </Typography>
        </Box>
      </Box>
      <Box id="image-container" sx={imageContainerStyle}>
        <MoveableImage
          src={machinedrum}
          alt="A poster design for the Elektron Machinedrum made in Adobe Illustrator"
          headline="Illustrator - Machinedrum Poster"
          description="The aim of this poster design was to create a visually captivating layout that captures the quick guide of the Machinedrum, conveying its functionalities in a clear and aesthetic manner.
"
        />

        <MoveableImage
          src={Glitch1}
          alt="A photo of a landscape with a glitch effect made in Adobe Photoshop"
          headline="Photoshop - Glitch Landscape 1"
          description="By adjusting brightness, contrast, and color values in Photoshop, unique glitch patterns can be generated in digital images. Small changes to these parameters can create distortions and unexpected effects, transforming a simple photo into a visually intriguing photograph."
        />

        <MoveableImage
          src={Flower1}
          alt="A scan of dried/dead flowers."
          headline="Scan - Dead Flower 1"
          description="Here you see a scan of dried/dead flowers. These can be used as print templates or backgrounds for various media."
        />

        <MoveableImage
          src={Project1}
          alt="A dashboard design for a project management tool made in Figma"
          headline="Figma - Dashboard Design"
          description="This is a dashboard design for a project management tool. It showcases a modern and user-friendly interface for managing projects and tasks. Made in Figma using Autolayout"
        />

        <MoveableImage
          src={Q}
          alt="A poster design - topic QANON"
          headline="Illustrator - Q Poster"
          description="Q symbolizes the rise of the outcasts, cloaked in garments heavy with the weight of history. Those who set the world ablaze are the very ones who benefit the most from it, glorifying something they believe to be the better path."
        />

        <MoveableImage
          src={Rotation}
          alt="A GIF of a ring rotating around its central axis."
          headline="Blender - Ring Animation"
          description="Blender Animation of a ring rotating around its central axis. Nodeling, texturing, lighting and animation created in Blender."
        />

        <MoveableImage
          src={Hoods}
          alt="3D model of Shimano AERO brake lever hoods"
          headline="Blender - Shimano AERO Hoods"
          description="This is a 3D model of a Shimano AERO Hood. Perfectly suited for the original brake lever of the Shimano AERO series. Working as a 3D print with TPU filament."
        />
        <MoveableImage
          src={Glitch2}
          alt="A photo of a landscape with a glitch effect made in Adobe Photoshop"
          headline="Photoshop - Glitch Landscape 2"
          description="By adjusting brightness, contrast, and color values in Photoshop, unique glitch patterns can be generated in digital images. Small changes to these parameters can create distortions and unexpected effects, transforming a simple photo into a visually intriguing photograph."
        />
        <MoveableImage
          src={Bremsschuhe}
          alt="3D model of Shimano AERO brake shoes"
          headline="Blender - Shimano AERO Brake Shoes"
          description="This is a 3D model of a Shimano AERO Brake Shoe. Perfectly suited for the original brakes of the Shimano AERO series. Working as a 3D print with TPU filament."
        />

        <MoveableImage
          src={Flower2}
          alt="A scan of dried/dead flowers." 
          headline="Scan - Dead Flower 2"
          description="Here you see a scan of dried/dead flowers. These can be used as print templates or backgrounds for various media."
        />
      </Box>
    </Box>
  );
};

export default Design;
